// extracted by mini-css-extract-plugin
export var centerText = "_7m-8";
export var container = "_7m-0";
export var doughnutContainer = "_7m-7";
export var legend = "_7m-a";
export var legendItemColorDisplay = "_7m-b";
export var legendItemLabel = "_7m-d";
export var legendItemValue = "_7m-c";
export var lg = "_7m-5";
export var maxWidth = "_7m-9";
export var md = "_7m-4";
export var responsive = "_7m-6";
export var sm = "_7m-3";
export var xs = "_7m-2";
export var xxs = "_7m-1";